import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root',
})
export class FcDiscountService {
  constructor(private _api: ApiService, private _message: MessageService) {}

  // Dummy API 1: Apply Discount
  async applyDiscount(payload: {}): Promise<boolean> {
    try {
      const response = await this._api.applyDiscount(payload).toPromise();
      ((response || {}).data || {}).status === 1
        ? this._message.showSuccess( ((response || {}).data || {}).message)
        : this._message.showError( ((response || {}).data || {}).message);
      return  ((response || {}).data || {}).status === 1;
    } catch (error) {
      console.error(error);
      this._message.showError(error.msg);
      return false;
    }
  }

  // Dummy API 2: List of Discounts
  async getDiscounts(payload): Promise<any[]> {
    try {
      const response = await this._api.getDiscounts(payload).toPromise();
      ((response || {}).data || {}).status !== 1
        && 
         this._message.showError( ((response || {}).data || {}).message);
      return  ((response || {}).data || {}).data || [];
    } catch (error) {
      console.error(error);
      this._message.showError(error.msg);
      return [];
    }
  }

  // Dummy API 3: Remove Discount
  async removeDiscount(type, payload: {}): Promise<boolean> {
    try {
      const response = await this._api[
        type === 1 ? 'removeAllDiscount' : 'removeDiscount'
      ](payload).toPromise();
      ((response || {}).data || {}).status === 1
        ? this._message.showSuccess(((response || {}).data || {}).message)
        : this._message.showError( ((response || {}).data || {}).message);
      return  ((response || {}).data || {}).status === 1;
    } catch (error) {
      console.error(error);
      this._message.showError(error.msg);
      return false;
    }
  }
}
